import React from 'react';
import { useDisplaySettings } from '../hooks/useDisplaySettings';

/**
 * DimOverlay — CSS brightness dimming for web/fallback.
 * Renders a semi-transparent black overlay proportional to (100 - brightness).
 * pointer-events: none so it doesn't block interaction.
 * z-index 55: above app content, below SleepOverlay (60) and screensaver (50... actually screensaver is 50, so this is above it).
 */
export function DimOverlay() {
  const { settings } = useDisplaySettings();

  if (settings.brightness >= 100) return null;

  const alpha = (100 - settings.brightness) / 100;

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 55,
        backgroundColor: `rgba(0, 0, 0, ${alpha})`,
        pointerEvents: 'none',
      }}
      aria-hidden="true"
    />
  );
}
